//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime, formatConfiguredTime } from '../../../../../components/helpers.js'
import { axiosGet } from '../../../../../axios/axios.js'
import UpdatesManager from '../../../../../components/UpdatesManager.js'

import BottomBar from './components/BottomBar.vue'
import MainInfoColumn from './components/MainInfoColumn.vue'
import LeftSidebar from './components/LeftSidebar.vue'
import TurnSummary from './components/TurnSummary.vue'
// import TopConstructionDepartmentGBUBlock from './components/TopConstructionDepartmentGBUBlock.vue'
import ClockBlock from './components/ClockBlock.vue'
import HeaderSidebar from './components/HeaderSidebar.vue'
import AdditionalInfoBottom from './components/AdditionalInfoBottom.vue'
import AdditionalInfoRight from './components/AdditionalInfoRight.vue'
import Efficiency from './components/Efficiency.vue'

export default {
  components: {
    MainInfoColumn,
    BottomBar,
    TurnSummary,
    HeaderSidebar,
    AdditionalInfoBottom,
    AdditionalInfoRight,
    ClockBlock,
    LeftSidebar,
    Efficiency
  },
  data: function () {
    return {
      sourceClaims: [],
      dateUpdateStatistic: null,
      dataStatistics: null,
      date: null,
      mounted: false,
      scale: 1,
      updatesManager: new UpdatesManager({
        autoUpdate: true,
        autoUpdateTimeout: 300000,
        updateFn: () => {
          return this.updateDataStatistics()
        }
      }),
      mountedChildrenCount: 0
    }
  },
  computed: {
    mainColumnsSource: function () {
      return this.sourceClaims && [this.sourceClaims[1], this.sourceClaims[3], this.sourceClaims[2]] || []
    },
    onlyTurn: function () {
      return this.$route && this.$route.path === '/statisticClaimRoadsTurn'
    },
    tlsHLRouteSource: function () {
      return this.getRouteSourceByType('tlsHL')
    },
    constructionDepartmentGBU: function () {
      return this.getRouteSourceByType('constructionDepartmentGBU')
    },
    additionalRouteSources: function () {
      const mainTypes = ['tlsHL', 'totalTodayHL', 'blackAndYellowHL', 'rmsOkoHL', 'actualizationHL', 'overdueHL', 'turnHL']
      return this.sourceClaims && this.sourceClaims.length > 0 && this.sourceClaims.flatMap(claim => claim.routeSource).filter(routeSource => routeSource.type && !mainTypes.includes(routeSource.type)) || null
    },
    additionalRouteSourcesRight: function () {
      return this.additionalRouteSources && this.additionalRouteSources.filter(routeSource => routeSource.type === 'constructionDepartment' || routeSource.type === 'constructionDepartmentRay')
    },
    additionalRouteSourcesBottom: function () {
      return this.additionalRouteSources && this.additionalRouteSources.filter(routeSource => routeSource.type !== 'constructionDepartment' && routeSource.type !== 'actualizationHL2024' && routeSource.type !== 'constructionDepartmentGBU' && routeSource.type !== 'constructionDepartmentRay')
    },
    mountedChildren: function () {
      if (!this.onlyTurn) {
        return this.mountedChildrenCount === (this.mainColumnsSource.length + 1)
      } else {
        return this.mountedChildrenCount === this.mainColumnsSource.length
      }
    },
    innerStyle: function () {
      const s = this.scale
      const offsetX = (window.innerWidth - 1920 * s) / 2
      const offsetY = (window.innerHeight - 1080 * s) / 2
      return {
        transformOrigin: 'top left',
        transform: `scale(${s})`,
        top: offsetY + 'px',
        left: offsetX + 'px'
      }
    }
  },
  watch: {
    $route: {
      handler: function (value) {
        if (value.query.date) {
          this.date = value.query.date
        } else {
          this.date = null
        }
      },
      immediate: true
    },
    mounted: function () {
      if (this.mounted && this.mountedChildren && this.dataStatistics != null) {
        this.addScreenshotClass()
      }
    },
    mountedChildren: function () {
      if (this.mounted && this.mountedChildren && this.dataStatistics != null) {
        this.addScreenshotClass()
      }
    },
    dataStatistics: {
      handler: function (result) {
        if (result != null) {
          this.dateUpdateStatistic = convertTime(result.calcTime)
          this.sourceClaims = JSON.parse(JSON.stringify(result.data))

          if (this.mounted && this.mountedChildren) {
            this.addScreenshotClass()
          }
        } else {
          this.sourceClaims = []
          if (this.date) {
            const dateMs = Date.parse(this.date)
            this.dateUpdateStatistic = formatConfiguredTime(dateMs, { year: true, month: true, date: true })
          } else {
            this.dateUpdateStatistic = null
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted () {
    this.mounted = true
    if (!this.onlyTurn) {
      this.computeScale()
      window.addEventListener('resize', this.computeScale)
    }
  },
  beforeDestroy: function () {
    this.updatesManager.destroy()
    window.removeEventListener('resize', this.computeScale)
  },
  created: function () {
    this.updatesManager.onUpdate()
  },
  methods: {
    computeScale: function () {
      this.scale = Math.min(
        window.innerWidth / 1920,
        window.innerHeight / 1080
      )
    },
    onMainInfoColumnMounted: function () {
      this.mountedChildrenCount++
    },
    addScreenshotClass: function () {
      this.$nextTick(() => {
        const $statisticClaimRoadsFull = document.querySelector('.statistic-claim-roads-full')
        if ($statisticClaimRoadsFull) {
          $statisticClaimRoadsFull.classList.add('screenshot_area')
        }
      })
    },
    getRouteSourceByType: function (type) {
      return this.sourceClaims && this.sourceClaims.length > 0 && this.sourceClaims.flatMap(claim => claim.routeSource).find(routeSource => routeSource.type && routeSource.type === type) || null
    },
    updateDataStatistics: function () {
      return axiosGet({
        url: `/vis/requestStatistics/onetouch${this.date ? `?date=${this.date}` : ''}`,
        onSuccess: (response) => {
          if (response && response.data && Object.keys(response.data).length) { // учитывая случай data: {}
            this.dataStatistics = response.data
          } else {
            this.dataStatistics = null
          }
        },
        onFailure: (response) => {
          const mes = response.message ? response.message : 'Ошибка получения статистики!'
          this.$q.notify({
            type: 'negative',
            message: mes,
            progress: true,
            timeout: 10000
          })
        }
      })
    }
  }
}
